import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaicarrentalservice() {



  const cardData = {
    keyword: " Mumbai Car Rental Service ",


"headingDescription": "Royal Route Cab offers reliable and affordable Mumbai car rental services, providing safe, comfortable, and flexible travel solutions for local use, airport transfers, corporate travel, and outstation trips. Whether you need a car for a few hours, a full day, or long-distance travel, our professional drivers and well-maintained fleet ensure a smooth and stress-free experience. We offer transparent pricing with no hidden charges and 24/7 availability for instant bookings. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for solo travelers, families, and group travel. With easy online booking and quick customer support, Royal Route Cab is your trusted choice for car rental service in Mumbai.",

"topPlaces": [
  {
    "title": "Lonavala",
    "description": "Lonavala is one of the most popular outstation destinations from Mumbai, known for its lush green hills, waterfalls, and scenic viewpoints. Attractions such as Bhushi Dam, Tiger’s Leap, and Rajmachi Point make it a perfect weekend getaway for families and couples."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a beautiful hill station famous for strawberry farms, scenic valleys, and breathtaking viewpoints. Popular attractions include Venna Lake, Arthur’s Seat, Wilson Point, and Mapro Garden, making it a favorite destination for nature lovers."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi is one of India's most important pilgrimage destinations, attracting millions of devotees every year to the Sai Baba Temple. Travelers from Mumbai frequently visit Shirdi for spiritual experiences and peaceful darshan."
  },
  {
    "title": "Nashik",
    "description": "Nashik is a renowned religious and wine tourism destination located near Mumbai. Famous attractions include Trimbakeshwar Temple, Sula Vineyards, Panchavati, and Godavari Ghats, offering a blend of spirituality and leisure."
  },
  {
    "title": "Matheran",
    "description": "Matheran is a charming eco-friendly hill station where vehicles are not allowed, offering a peaceful retreat from city life. Visitors enjoy toy train rides, panoramic viewpoints, forest trails, and fresh mountain air."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a coastal getaway known for its clean beaches, sea forts, and relaxing atmosphere. Popular attractions include Alibaug Beach, Kolaba Fort, and Varsoli Beach, making it a preferred destination for weekend trips."
  },
  {
    "title": "Pune",
    "description": "Pune is a vibrant city rich in history, culture, and modern attractions. Visitors can explore Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, and Dagdusheth Ganpati Temple while enjoying the city's lively atmosphere."
  },
  {
    "title": "Igatpuri",
    "description": "Igatpuri is a picturesque hill station nestled in the Sahyadri ranges, known for misty mountains, waterfalls, and lush greenery. It is especially popular during the monsoon season and among nature enthusiasts."
  },
  {
    "title": "Aurangabad",
    "description": "Aurangabad is famous for the UNESCO World Heritage Sites of Ajanta and Ellora Caves. The city also offers historical attractions such as Bibi Ka Maqbara and Daulatabad Fort, making it a must-visit destination for history lovers."
  },
  {
    "title": "Goa",
    "description": "Goa is one of the most sought-after outstation destinations from Mumbai, known for its beautiful beaches, vibrant nightlife, Portuguese heritage, and water sports. It is ideal for vacations, family trips, and group tours."
  }
],






services: [
  {
    name: "Mumbai Car Rental Service",
    description: "Mumbai car rental service offers flexible and convenient transportation solutions for local, airport, and outstation travel. Customers can choose from a wide range of vehicles based on their needs. Professional drivers and well-maintained cars ensure comfort and safety. Ideal for personal and corporate use. It guarantees a smooth and hassle-free travel experience."
  },
  {
    name: "Car Hire in Mumbai",
    description: "Car hire in Mumbai provides easy access to vehicles for short and long-term use. This service is perfect for business trips, family outings, and daily commuting. Customers can select from multiple vehicle options. It ensures flexible and reliable travel solutions."
  },
  {
    name: "Self Drive Car Rental Mumbai",
    description: "Self drive car rental Mumbai allows customers to rent vehicles and drive themselves for complete flexibility. This service is ideal for travelers who prefer privacy and independence. Well-maintained cars and easy booking options enhance convenience. It ensures a personalized travel experience."
  },
  {
    name: "Chauffeur Driven Car Rental Mumbai",
    description: "Chauffeur driven car rental Mumbai offers professional driver services for comfortable and stress-free travel. This service is ideal for business meetings, events, and airport transfers. Experienced drivers ensure safe and smooth journeys. It guarantees a premium travel experience."
  },
  {
    name: "Car Rental Booking Mumbai",
    description: "Car rental booking Mumbai allows customers to reserve vehicles easily with flexible options. Travelers can select vehicle type, pickup location, and timing. Instant confirmation and transparent pricing ensure convenience. It simplifies travel planning."
  },
  {
    name: "Cheap Car Rental Mumbai",
    description: "Cheap car rental Mumbai offers budget-friendly vehicle options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical cars are available for daily use. Transparent pricing ensures no hidden charges. It ensures affordable travel."
  },
  {
    name: "Luxury Car Rental Mumbai",
    description: "Luxury car rental Mumbai provides premium vehicles for high-end travel and special occasions. This service includes luxury sedans and SUVs with professional chauffeurs. Comfortable interiors and stylish rides enhance the experience. It ensures a luxurious journey."
  },
  {
    name: "Daily Car Rental Mumbai",
    description: "Daily car rental Mumbai offers vehicles for full-day usage with flexible packages. This service is ideal for business trips, sightseeing, and personal travel. Multiple vehicle options are available. It ensures convenience and comfort for day-long travel."
  },
  {
    name: "Hourly Car Rental Mumbai",
    description: "Hourly car rental Mumbai provides short-term vehicle rental options for city travel. This service is perfect for quick trips, meetings, and errands. Flexible pricing based on hours enhances convenience. It ensures efficient and cost-effective travel."
  },
  {
    name: "Airport Car Rental Mumbai",
    description: "Airport car rental Mumbai offers convenient pickup and drop services to all airport terminals. This service ensures timely transfers for flights. Professional drivers and clean vehicles enhance comfort. Ideal for business travelers and tourists. It ensures a stress-free airport experience."
  },
  {
    name: "Outstation Car Rental Mumbai",
    description: "Outstation car rental Mumbai provides reliable travel to nearby cities and long-distance destinations. This service includes one way and round trip options. Vehicles are maintained for highway performance. It ensures safe and comfortable journeys."
  },
  {
    name: "SUV Rental Mumbai",
    description: "SUV rental Mumbai offers spacious and comfortable vehicles for family and group travel. SUVs provide extra space and better performance for long journeys. Suitable for city and outstation travel. It ensures a comfortable experience."
  },
  {
    name: "Sedan Rental Mumbai",
    description: "Sedan rental Mumbai is ideal for individuals and small families seeking affordable and comfortable travel. Sedans offer smooth rides and good mileage. Suitable for local and airport travel. It ensures a pleasant journey."
  },
  {
    name: "Innova Rental Mumbai",
    description: "Innova rental Mumbai provides premium MPV vehicles ideal for group travel and corporate trips. Spacious seating and comfort make it suitable for long journeys. Professional drivers ensure safety. It offers a premium travel experience."
  },
  {
    name: "Ertiga Rental Mumbai",
    description: "Ertiga rental Mumbai is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. Ideal for local and outstation travel. It ensures a smooth and enjoyable journey."
  },
  {
    name: "Best Car Rental Service Mumbai",
    description: "Best car rental service Mumbai ensures top-quality vehicles, professional drivers, and excellent customer support. This service focuses on comfort, safety, and reliability. Multiple vehicle options are available. It guarantees a premium and hassle-free travel experience."
  }
],

tableData: [
  ["Mumbai Car Rental Service", "Car Hire in Mumbai"],
  ["Self Drive Car Rental Mumbai", "Chauffeur Driven Car Rental Mumbai"],
  ["Car Rental Booking Mumbai", "Cheap Car Rental Mumbai"],
  ["Luxury Car Rental Mumbai", "Daily Car Rental Mumbai"],
  ["Hourly Car Rental Mumbai", "Airport Car Rental Mumbai"],
  ["Outstation Car Rental Mumbai", "SUV Rental Mumbai"],
  ["Sedan Rental Mumbai", "Innova Rental Mumbai"],
  ["Ertiga Rental Mumbai", "Best Car Rental Service Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Flexible Car Rental Service in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers flexible car rental services in Mumbai for hourly, daily, and outstation travel needs."
  },
  {
    WhyChooseheading: "Wide Range of Rental Options",
    WhyChoosedescription: "Choose from self-drive alternatives with driver-based rentals including local rides, airport transfers, and long-distance travel."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are trained, punctual, and experienced in handling city routes and long journeys across Mumbai."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "We provide clear and upfront pricing with no hidden costs, ensuring complete transparency in car rental bookings."
  },
  {
    WhyChooseheading: "24/7 Car Rental Availability",
    WhyChoosedescription: "Our Mumbai car rental service is available 24/7, allowing you to book vehicles anytime for any purpose."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All vehicles are regularly serviced, sanitized, and maintained to ensure a comfortable and safe travel experience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and luxury vehicles for all needs."
  },
  {
    WhyChooseheading: "Trusted Car Rental Provider",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable and affordable car rental services across Mumbai."
  }
]

};

const faqData = [
  { question: "Do you provide car rental service in Mumbai?", answer: "Yes, Royal Route Cabs offers reliable car rental services in Mumbai for local and outstation travel." },
  { question: "What types of rental services are available?", answer: "We provide hourly rentals, full-day rentals, airport transfers, and outstation car rental services." },
  { question: "Is car rental available 24 hours?", answer: "Yes, our Mumbai car rental service operates 24/7." },
  { question: "Which vehicles are available for rent?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and luxury vehicles." },
  { question: "Are drivers included with rental?", answer: "Yes, all our car rentals come with professional drivers." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide airport rental services?", answer: "Yes, we offer car rental services for Mumbai airport pickup and drop." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Deshmukh",
    feedback: "Royal Route Cabs provided a very smooth car rental experience in Mumbai. The vehicle was clean, well-maintained, and the service was prompt and professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shruti Mehta",
    feedback: "Excellent Mumbai car rental service with Royal Route Cabs. The entire process was hassle-free and the ride quality made our travel very comfortable.",
    rating: 5
  }
];
















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Car Rental Service",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-car-rental-service.jpg", // replace if needed
  "description": "Book Mumbai car rental service with Royal Route Cabs for reliable and affordable travel. Choose from chauffeur-driven sedans, SUVs, Innova, Ertiga, and luxury cars for local, airport, and outstation trips. 24x7 service available.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999", // starting rental price (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-car-rental-service"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai Car Rental Service | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai car rental service with Royal Route Cabs. Affordable chauffeur-driven cars for local, airport, and outstation travel. Sedan, SUV, Innova & luxury cars available 24x7."
  />

  <meta
    name="keywords"
    content="mumbai car rental service, car hire in mumbai, self drive car rental mumbai, chauffeur driven car rental mumbai, car rental booking mumbai, cheap car rental mumbai, luxury car rental mumbai, daily car rental mumbai, hourly car rental mumbai, airport car rental mumbai, outstation car rental mumbai, suv rental mumbai, sedan rental mumbai, innova rental mumbai, ertiga rental mumbai, best car rental service mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/33.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaicarrentalservice;